import { defineComponent, ref, watch } from "vue";
import { debounce } from "lodash";
import ajaxSearch from "@/services/ajaxSearch";
import { Link } from "@/interfaces/Link";

export default defineComponent({
  props: {
    toggleSidebar: { type: Function, required: true },
  },

  setup(props) {
    const loading = ref(false);
    const searchInput = ref("");
    const searchInputElement = ref<HTMLElement | null>(null);
    const searchResults = ref<{ page: Link[]; post: Link[]; agenda: Link[] }>({
      page: [],
      post: [],
      agenda: [],
    });
    const showNotification = ref(false);
    const notification = ref("");

    watch(searchInput, (currentValue) => {
      if (currentValue.length > 2) {
        showNotification.value = false;
        loading.value = true;
        debouncedSearch();
      } else {
        searchResults.value.page = [];
        searchResults.value.post = [];
        searchResults.value.agenda = [];

        if (currentValue.length === 0) {
          showNotification.value = false;
          loading.value = false;
        } else {
          showNotification.value = true;
          notification.value = "Voer minimaal 3 karakters in";
        }
      }
    });

    const debouncedSearch = debounce(async () => {
      if (searchInput.value.length > 2) {
        search();
      }
    }, 200);

    async function search(): Promise<void> {
      searchResults.value = await ajaxSearch.searchTerm(searchInput.value);

      if (
        searchResults.value.page.length < 1 &&
        searchResults.value.post.length < 1 &&
        searchResults.value.agenda.length < 1
      ) {
        showNotification.value = true;
        notification.value = "Er zijn geen resultaten gevonden.";
      } else {
        showNotification.value = false;
      }

      loading.value = false;
    }

    const clearInput = (): void => {
      searchInput.value = "";
      searchInputElement.value!.focus();
    };

    const closeSearch = (): void => {
      const dummyEvent = new Event("click");

      props.toggleSidebar(dummyEvent);
    };

    return {
      loading,
      searchInputElement,
      searchResults,
      searchInput,
      clearInput,
      showNotification,
      notification,
      closeSearch,
    };
  },
});
